import { blockCategories } from '../../categories';

export default (editor) => {
    editor.DomComponents.addType('divider', {
        model: {
            defaults: {
                tagName: 'hr',
                draggable: true,
                droppable: false,
                traits: [],
                attributes: {
                    class: 'gjs-divider',
                },
                style: {
                    "border": '1px solid #ccc',
                    margin: '20px 0',
                },

            },
        },
    });

    editor.BlockManager.add('divider', {
        label: 'Trenner',
        category: blockCategories.basic,
        content: {
            type: 'divider',
        },
        attributes: { class: '' },
        media: `<svg viewBox="0 0 24 24">
          <path d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z"></path>
        </svg>`,
    });
};
